module.exports = __webpack_public_path__ + "img/person-fill.40a41000.svg";